import { CREATE_POST, POST_DATA, POST_DETAILS, REMOVE_POST_DATA } from "./ActionType";

const initialValue={
   createpost:null,
   postdetails:[],
   postdata:[],
   removepostdata:null,
}

export const socialPostReducer=(store=initialValue, {type,payload})=>{

    if(type===CREATE_POST){
        return {
            ...store,createpost:  payload, 
        };
    }else if(type===POST_DETAILS){
        return {
            ...store,postdetails:  payload.socialPostDto || [], 
        };
    }else if(type===POST_DATA){
        return {
            ...store,postdata:  payload.socialPostDto || [], 
        };
    }else if(type===REMOVE_POST_DATA){
        return {
            ...store,removepostdata:  payload, 
        };
    }

    return store
}